import React from 'react';
import GenericDialog from '@common/GenericDialog';

const AnswerKeyDialog = ({
                             open,
                             onClose,
                             onPrintAnswerKey,
                             selectedSingleTest,
                         }) => {
    return (
        <GenericDialog
            title={`Print ${selectedSingleTest?.name} answer key`}
            open={open}
            onClose={onClose}
            buttons={[
                {
                    name: 'Cancel',
                    extraProps: { type: 'text' },
                },
                {
                    name: 'Print',
                    callback: onPrintAnswerKey,
                },
            ]}
        >
            <p>Would you like to print the answer key for “{selectedSingleTest?.name}”?</p>
        </GenericDialog>
    );
};

export default AnswerKeyDialog;
